import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setHoveredThumbnail, setIsHovered } from "../../store/ShelfView/popover";
import axios from "axios";
const get_image_url = async (image) => {
	try {
		const urlData = await axios.post("/get_context/getImageURL", {
			"imageName": image,
			"folderName":"audit_images"
		})
		const imageUrl = urlData.data;
		console.log(imageUrl,"LINE 51")
		return imageUrl
	} catch (error) {
		console.error("Error fetching image:", error.message);
		return null;
	}
};
// const get_image_url = (image) => {
//     return (
//       `https://caiproduction002.blob.core.windows.net/ira/audit_images/` +
//       image +
//       `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`
//     );
// };

const GenerateThumbnail = ({data,type}) => {
 // console.log("thumbnail props", props)
    let props={...data}
    //console.log(props,type)
    const imageUrl = get_image_url(props.imageName);
    const xmin = props.xmin;
    const ymin = props.ymin;
    const xmax = props.xmax;
    const ymax = props.ymax;
    const canvasRef = useRef(null);
    const [cropDim, setCropDim] = useState([]);
  
    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, xmax - xmin, ymax - ymin);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imageUrl;
      img.onload = async () => {
        const cropX = xmin; // X-coordinate of the top-left corner of the crop area
        const cropY = ymin; // Y-coordinate of the top-left corner of the crop area
        const cropWidth = xmax - xmin; // Width of the crop area
        const cropHeight = ymax - ymin; // Height of the crop area
  
        setCropDim([cropWidth, cropHeight]);
  
        canvas.width = cropWidth;
        canvas.height = cropHeight;
        ctx.drawImage(
          img,
          cropX,
          cropY,
          cropWidth,
          cropHeight,
          0,
          0,
          cropWidth,
          cropHeight
        );
      };
    }, [imageUrl, xmin, xmax, ymin, ymax]);
  
    const width = cropDim[0];
    const height = cropDim[1];
  
    const ratio = width / height;
     let dynamicHeight = 170;

    const dynamicWidth = dynamicHeight * ratio;
    
    const windowHeight = window.innerHeight;
    let setWidth=10;
    let setHeight=23;

    // dynamicHeight = windowHeight <= 830 ? 150 : 170;
    if(windowHeight <= 730)
    {
      setWidth = 10;
      setHeight = 22;
    }
    if (windowHeight <= 830) {
      setWidth = 9;
      setHeight = 19;
    } else if (windowHeight <= 930) {
      setWidth = 8;
      setHeight = 17;
    } else if (windowHeight <= 990) {
      setWidth = 7;
      setHeight = 17;
    } else if (windowHeight <= 1110) {
      setWidth = 6;
      setHeight = 16;
    } else {
      // Default values if none of the conditions are met
      setWidth = 10;
      setHeight = 22;
    }
   
    return (
      <div className="thumbnail">
        {type === "savethumbnail"?  <canvas
          ref={canvasRef}
          style={{ width: setWidth+ `vw`, height: setHeight + `vh` }}
         
        />:  <canvas
        ref={canvasRef}
        style={{ width: dynamicWidth + `px`, height: dynamicHeight + `px` }}
       
      />}
      
    
      </div>
    );
  };

  export default GenerateThumbnail;